export default __webpack_public_path__ + "static/media/3.4ef0e03b.png";